import { Data } from 'signup-constants/signupData/Data';
import { isCodeVerificationSignup, isExistingUser } from '../app/verificationTypeSelectors';
export const addRequiredVerificationData = state => {
  // eslint-disable-next-line no-nested-ternary
  return isExistingUser(state) ? [] : isCodeVerificationSignup(state) ? [Data.CodeVerification] : [Data.Token];
};